export enum UisAuthenticationErrors {
  NoSuchAttribute = 'No Such Attribute',
  ChangedPasswordConstraintViolation = 'constraint.violation',
  ConstraintViolation = 'Constraint Violation',
  NewPasswordHistoryViolation = 'new.password.validation.failed.:history',
  LinkExpired = 'magicLink.date.expired',
  NameOrPasswordIncorrect = 'username.or.password.is.incorrect',
  Unexpected = 'Unexpected',
  UserDisabled = 'user.disabled',
  UserLockedOut = 'user.locked.out',
  PasswordExpired = 'password.is.expired',
  RedirectUriNotValid = 'redirect.uri.is.not.valid',
  Other = 'Other',
  UnauthorizedDomainAccess = 'UNAUTHORIZED_DOMAIN_ACCESS',
}
